import { render, staticRenderFns } from "./HorizontalResize.vue?vue&type=template&id=cf515740&scoped=true&lang=pug"
import script from "./HorizontalResize.vue?vue&type=script&lang=ts"
export * from "./HorizontalResize.vue?vue&type=script&lang=ts"
import style0 from "./HorizontalResize.vue?vue&type=style&index=0&id=cf515740&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf515740",
  null
  
)

export default component.exports